import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { ExportEffects } from "./export.effects";
import { reducer } from "./export.reducer";

@NgModule({
	imports: [StoreModule.forFeature("export", reducer), EffectsModule.forFeature([ExportEffects])],
})
export class ExportStateModule {}
